"use client";
import { motion } from "motion/react";
import { Gift } from "lucide-react";

interface PackageInclusionSectionProps {
  inclusionHTML: string;
}

export default function PackageInclusionSection({
  inclusionHTML,
}: PackageInclusionSectionProps) {
  if (!inclusionHTML) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.1 }}
      className="bg-[#F9F7F4] rounded-2xl p-8"
    >
      <div className="flex items-center gap-3 mb-6">
        <Gift className="h-8 w-8 text-[#B42025]" />
        <h2 className="text-3xl text-[#1A1A1A]">Package Inclusions</h2>
      </div>
      <div
        className="prose prose-lg max-w-none package-inclusion"
        dangerouslySetInnerHTML={{ __html: inclusionHTML }}
      />
    </motion.div>
  );
}
